import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/store';
const fb = require('../firebaseConfig.js');

//import VueFire from 'vuefire';
//import "./registerServiceWorker";

//Vue.use(VueFire)
Vue.config.productionTip = false

let app;
fb.auth.onAuthStateChanged(user => {
    if (!app) {
        app = new Vue({
            router,
            store,
            render: h => h(App),
        }).$mount('#app')

        if (user) {
            console.log(user);
            store.commit('setCurrentUser', user);
            store.dispatch('fetchUserProfile');
            //dispatch('initRecipes');

            if (!Object.keys(store.state.recipes.recipes).length) {
                store.dispatch("initRecipes");
            }

            /*if (!recipes.state.recipes.length) {
                console.log(recipes.state.recipes === {});
            }*/
        }
    }
});

//export const db = firebase.firestore()